// extracted by mini-css-extract-plugin
module.exports = {"description":"Modal_description__24cal"};